<div class="upload-lpo-container">
  <!-- Header Bar (matching generate LPO style) -->
  <div class="upload-header">
    <div class="header-title">
      <h2>{{ data.lpoUrl ? "View LPO" : "Upload LPO" }}</h2>
      <p>
        {{
          data.lpoUrl
            ? "Preview the attached LPO document."
            : "Upload a PDF or image as your LPO attachment."
        }}
      </p>
    </div>
    <div class="spacer"></div>
    <button
      mat-button
      (click)="close()"
      [disabled]="isUploading"
      class="cancel-btn"
    >
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="!previewUrl || selectedFile"
      (click)="uploadLPO()"
      [disabled]="isUploading || !selectedFile"
    >
      <mat-icon>upload</mat-icon>
      {{ previewUrl ? "Replace LPO" : "Upload LPO" }}
    </button>
  </div>

  <!-- Content Area -->
  <div class="upload-scroll-area">
    <!-- Preview Mode -->
    <div
      *ngIf="previewUrl && !selectedFile; else uploadSection"
      class="preview-wrapper"
    >
      <ng-container *ngIf="previewUrl.endsWith('.pdf'); else imagePreview">
        <embed
          [src]="previewUrl"
          type="application/pdf"
          width="100%"
          height="500px"
          class="pdf-embed"
        />
      </ng-container>
      <ng-template #imagePreview>
        <img [src]="previewUrl" alt="LPO Preview" class="preview-image" />
      </ng-template>
    </div>

    <!-- Upload Section -->
    <ng-template #uploadSection>
      <div class="upload-card">
        <div class="upload-drop-zone">
          <div class="upload-icon">
            <mat-icon>picture_as_pdf</mat-icon>
          </div>
          <p class="upload-hint">
            Select a PDF or image to upload as your LPO.
          </p>

          <input
            type="file"
            #fileInput
            (change)="onFileSelected($event)"
            accept=".pdf,image/*"
            hidden
          />

          <button
            mat-stroked-button
            color="primary"
            (click)="openFilePicker()"
            class="choose-file-btn"
          >
            <mat-icon>attach_file</mat-icon> Choose File
          </button>

          <div *ngIf="selectedFile" class="file-name-chip">
            <mat-icon>description</mat-icon>
            {{ selectedFile.name }}
          </div>

          <mat-progress-bar
            *ngIf="isUploading"
            mode="indeterminate"
            class="upload-progress"
          ></mat-progress-bar>
        </div>
      </div>
    </ng-template>
  </div>
</div>
